import "./App.css";
import Navbar from "./Components/navbar.js";
import Sidebar from "./Components/sidebar.js";
import Introduction from "./Components/introduction.js";
import Education from "./Components/education.js";
import Skills from "./Components/skills.js";
import Project from "./Components/projects";
import Certifications from "./Components/certifications.js";
import Contactme from "./Components/contactme.js";
import { useState } from "react";

function App() {
  const [index, setindex] = useState(0);
  const [sidebarstatus, setsidebar] = useState(true);
  return (
    <div className="App">
      <div>
        <Sidebar sidebarstatus={sidebarstatus} setsidebar={setsidebar} />
      </div>
      <div className="maincontent">
        <Navbar
          index={index}
          setindex={setindex}
          setsidebarstatus={setsidebar}
        />
        <div className="maincontent-components">
          <Introduction setindex={setindex} />
          <br />
          <br />
          <br />
          <br />
          <Education setindex={setindex} />
          <br />
          <br />
          <br />
          <br />
          <Skills setindex={setindex} />
          <br />
          <br />
          <br />
          <br />
          <Project setindex={setindex} />
          <br />
          <br />
          <br />
          <br />
          <Certifications setindex={setindex} />
          <br />
          <br />
          <br />
          <br />
          <Contactme setindex={setindex} />
        </div>
      </div>
    </div>
  );
}

export default App;
